import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LoaderModule } from '@app/shared';
import { PipeModule } from '@app/shared';

import { GoalBoxStatisticsColumnComponent } from './box-statistics-column.component';
import { GoalBoxStatisticsColumnWidgetComponent } from './widget/widget.component';
import { GoalLineGoalModule } from '../line-goal/line-goal.module';

@NgModule({
    imports: [CommonModule, RouterModule, NgbTooltipModule, TranslateModule, InlineSVGModule, LoaderModule, PipeModule, GoalLineGoalModule],
    declarations: [GoalBoxStatisticsColumnComponent, GoalBoxStatisticsColumnWidgetComponent],
    exports: [GoalBoxStatisticsColumnComponent],
})
export class GoalBoxStatisticsColumnModule {}
